<template>
  <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
    <v-container :class="$vuetify.breakpoint.xsOnly ? '' : 'elevation-2'">
      <v-autocomplete
        v-if="!this.campo || this.campo === 'nombre_campus'"
        @keyup.enter="$event.target.blur()"
        :label="labels.campus"
        v-model="form.nombre_campus"
        :items="campuses"
        item-text="nombre"
        item-value="nombre"
        :error-messages="errors.nombre_campus"
        :rules="[rules.required('nombre_campus')]"
        :disabled="loading"
        dense
        hide-no-data
      ></v-autocomplete>

      <v-autocomplete
        v-if="!this.campo || this.campo === 'nombre_carrera'"
        @keyup.enter="$event.target.blur()"
        :label="labels.carrera"
        v-model="form.nombre_carrera"
        :items="carreras"
        item-text="nombre"
        item-value="nombre"
        :error-messages="errors.nombre_carrera"
        :rules="[rules.required('nombre_carrera')]"
        :disabled="loading"
        dense
        hide-no-data
      ></v-autocomplete>

      <v-menu
        v-if="!this.campo || this.campo === 'fecha_inicio_carrera'"
        v-model="menuFechaInicioCarrera"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="fecha_inicio_carrera"
            :label="labels.fecha_inicio_carrera"
            :disabled="loading"
            readonly
            @blur="fecha_inicio_carrera = parseDate(fecha_inicio_carrera_formatted)"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="fecha_inicio_carrera"
          @input="menuFechaInicioCarrera = false"
          locale="es-es"
        ></v-date-picker>
      </v-menu>

      <v-menu
        v-if="!this.campo || this.campo === 'fecha_terminacion_carrera'"
        v-model="menuFechaTerminacionCarrera"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="form.fecha_terminacion_carrera"
            :label="labels.fecha_terminacion_carrera"
            :disabled="loading"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.fecha_terminacion_carrera"
          @input="fecha_terminacion_carrera = false"
          locale="es-es"
        ></v-date-picker>
      </v-menu>

      <v-autocomplete
        v-if="!this.campo || this.campo === 'autorizacion_reconocimiento'"
        @keyup.enter="$event.target.blur()"
        :label="labels.autorizacion_reconocimiento"
        v-model="form.autorizacion_reconocimiento"
        :items="autorizacionesReconocimientos"
        item-text="nombre"
        item-value="nombre"
        :error-messages="errors.autorizacion_reconocimiento"
        :rules="[rules.required('autorizacion_reconocimiento')]"
        :disabled="loading"
        dense
        hide-no-data
      ></v-autocomplete>

      <v-text-field
        v-if="!this.campo || this.campo === 'numero_rvoe'"
        :label="labels.numero_rvoe"
        v-model="form.numero_rvoe"
        :error-messages="errors.numero_rvoe"
        :rules="[rules.required('numero_rvoe')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'curp_profesionista'"
        :label="labels.curp_profesionista"
        v-model="form.curp_profesionista"
        :error-messages="errors.curp_profesionista"
        :rules="[rules.required('curp_profesionista')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'matricula_profesionista'"
        :label="labels.matricula_profesionista"
        v-model="form.matricula_profesionista"
        :error-messages="errors.matricula_profesionista"
        :rules="[rules.required('matricula_profesionista')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'nombre_profesionista'"
        :label="labels.nombre_profesionista"
        v-model="form.nombre_profesionista"
        :error-messages="errors.nombre_profesionista"
        :rules="[rules.required('nombre_profesionista')]"
        :disabled="loading"
      ></v-text-field>
      
      <v-text-field
        v-if="!this.campo || this.campo === 'primer_apellido_profesionista'"
        :label="labels.primer_apellido_profesionista"
        v-model="form.primer_apellido_profesionista"
        :error-messages="errors.primer_apellido_profesionista"
        :rules="[rules.required('primer_apellido_profesionista')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'segundo_apellido_profesionista'"
        :label="labels.segundo_apellido_profesionista"
        v-model="form.segundo_apellido_profesionista"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'correo_electronico'"
        :label="labels.correo_electronico"
        v-model="form.correo_electronico"
        :error-messages="errors.correo_electronico"
        :rules="[rules.required('correo_electronico')]"
        :disabled="loading"
      ></v-text-field>

      <v-menu
        v-if="!this.campo || this.campo === 'fecha_de_expedicion'"
        v-model="menuFechaExpedicion"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="form.fecha_de_expedicion"
            :label="labels.fecha_de_expedicion"
            :disabled="loading"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.fecha_de_expedicion"
          @input="menuFechaExpedicion = false"
          locale="es-es"
        ></v-date-picker>
      </v-menu>

      <v-autocomplete
        v-if="!this.campo || this.campo === 'modalidad_de_titulacion'"
        @keyup.enter="$event.target.blur()"
        :label="labels.modalidad_de_titulacion"
        v-model="form.modalidad_de_titulacion"
        :items="modalidadesTitulacion"
        item-text="nombre"
        item-value="nombre"
        :error-messages="errors.modalidad_de_titulacion"
        :rules="[rules.required('modalidad_de_titulacion')]"
        :disabled="loading"
        dense
        hide-no-data
      ></v-autocomplete>

      <v-text-field
        v-if="!this.campo || this.campo === 'fecha_examen_profesional'"
        :label="labels.fecha_examen_profesional"
        v-model="form.fecha_examen_profesional"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'fecha_exencion_examen_profesional'"
        :label="labels.fecha_exencion_examen_profesional"
        v-model="form.fecha_exencion_examen_profesional"
        :disabled="loading"
      ></v-text-field>

      <v-select
        v-if="!this.campo || this.campo === 'cumplio_servicio_social'"
        :label="labels.cumplio_servicio_social"
        v-model="form.cumplio_servicio_social"
        :items="cumplioServicioSocial"
        item-text="nombre"
        item-value="id"
        :error-messages="errors.cumplio_servicio_social"
        :rules="[rules.required('cumplio_servicio_social')]"
        :disabled="loading"
        dense
      ></v-select>

      <v-autocomplete
        v-if="!this.campo || this.campo === 'fundamento_legal_servicio_social'"
        @keyup.enter="$event.target.blur()"
        :label="labels.fundamento_legal_servicio_social"
        v-model="form.fundamento_legal_servicio_social"
        :items="fundamentoLegalServicioSocial"
        item-text="nombre"
        item-value="nombre"
        :error-messages="errors.fundamento_legal_servicio_social"
        :rules="[rules.required('fundamento_legal_servicio_social')]"
        :disabled="loading"
        dense
        hide-no-data
      ></v-autocomplete>

      <v-autocomplete
        v-if="!this.campo || this.campo === 'entidad_federativa_expedicion'"
        @keyup.enter="$event.target.blur()"
        :label="labels.entidad_federativa_expedicion"
        v-model="form.entidad_federativa_expedicion"
        :error-messages="errors.entidad_federativa_expedicion"
        :rules="[rules.required('entidad_federativa_expedicion')]"
        :disabled="loading"
        :items="entidadesFederativas"
        item-text="nombre"
        item-value="nombre"
        dense
        hide-no-data
      ></v-autocomplete>

      <v-text-field
        v-if="!this.campo || this.campo === 'institucion_procedencia'"
        :label="labels.institucion_procedencia"
        v-model="form.institucion_procedencia"
        :error-messages="errors.institucion_procedencia"
        :rules="[rules.required('institucion_procedencia')]"
        :disabled="loading"
      ></v-text-field>

      <v-autocomplete
        v-if="!this.campo || this.campo === 'tipo_estudio_antecedente'"
        @keyup.enter="$event.target.blur()"
        :label="labels.tipo_estudio_antecedente"
        v-model="form.tipo_estudio_antecedente"
        :items="tipoEstudioAntecedente"
        item-text="nombre"
        item-value="nombre"
        :error-messages="errors.tipo_estudio_antecedente"
        :rules="[rules.required('tipo_estudio_antecedente')]"
        :disabled="loading"
        dense
        hide-no-data
      ></v-autocomplete>

      <v-autocomplete
        v-if="!this.campo || this.campo === 'entidad_federativa_antecedente'"
        @keyup.enter="$event.target.blur()"
        :label="labels.entidad_federativa_antecedente"
        v-model="form.entidad_federativa_antecedente"
        :error-messages="errors.entidad_federativa_antecedente"
        :rules="[rules.required('entidad_federativa_antecedente')]"
        :disabled="loading"
        :items="entidadesFederativas"
        item-text="nombre"
        item-value="nombre"
        dense
        hide-no-data
      ></v-autocomplete>

      <v-menu
        v-if="!this.campo || this.campo === 'fecha_inicio_antecedente'"
        v-model="menuFechaInicioAntecedente"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="form.fecha_inicio_antecedente"
            :label="labels.fecha_inicio_antecedente"
            :disabled="loading"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.fecha_inicio_antecedente"
          @input="menuFechaInicioAntecedente = false"
          locale="es-es"
        ></v-date-picker>
      </v-menu>

      <v-menu
        v-if="!this.campo || this.campo === 'fecha_terminacion_antecedente'"
        v-model="menuFechaTerminacionAntecedente"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="form.fecha_terminacion_antecedente"
            :label="labels.fecha_terminacion_antecedente"
            :disabled="loading"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.fecha_terminacion_antecedente"
          @input="menuFechaTerminacionAntecedente = false"
          locale="es-es"
        ></v-date-picker>
      </v-menu>

      <v-text-field
        v-if="!this.campo || this.campo === 'numero_cedula'"
        :label="labels.numero_cedula"
        v-model="form.numero_cedula"
        :disabled="loading"
      ></v-text-field>
    </v-container>

    <v-layout justify-end mt-2>
      <v-btn
        flat
        :disabled="loading"
        @click="$router.go(-1)"
        color="grey darken-2"
      >
        Cancelar
      </v-btn>

      <v-btn
        type="submit"
        :loading="loading"
        :disabled="loading"
        color="primary"
      >
        Guardar
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      form: {},
      
      campuses: [],
      carreras: [],
      autorizacionesReconocimientos: [],
      modalidadesTitulacion: [],
      cumplioServicioSocial: [
        { id: '0', nombre: 'NO' },
        { id: '1', nombre: 'SI' }
      ],
      fundamentoLegalServicioSocial: [],
      entidadesFederativas: [],
      tipoEstudioAntecedente: [],

      campo: null,

      fecha_inicio_carrera: new Date().toISOString().substr(0, 10),
      fecha_inicio_carrera_formatted: null,

      menuFechaInicioCarrera: false,
      menuFechaTerminacionCarrera: false,
      menuFechaExpedicion: false,
      menuFechaInicioAntecedente: false,
      menuFechaTerminacionAntecedente: false,
    }),

    computed: {
      ...mapGetters({
        live_mode: "auth/live_mode",
      })
    },

    watch: {
      live_mode(val) {
        if (val !== undefined) {
          this.$router.push({ name: 'lotes-titulos' })
        }
      },

      fecha_inicio_carrera (val) {
        this.fecha_inicio_carrera_formatted = this.formatDate(this.fecha_inicio_carrera)
      }
    },

    mounted() {
      if(this.$route.params.campo) {
        this.campo = this.$route.params.campo
      } else {
        let tab = this.$route.fullPath.replace(this.$route.path, '').split('/')
        let param = decodeURI(tab[0].substr(1))
        if (
          param === 'nombre_campus' ||
          param === 'nombre_carrera' ||
          param === 'fecha_inicio_carrera' ||
          param === 'fecha_terminacion_carrera' ||
          param === 'autorizacion_reconocimiento' ||
          param === 'numero_rvoe' ||
          param === 'curp_profesionista' ||
          param === 'matricula_profesionista' ||
          param === 'nombre_profesionista' ||
          param === 'primer_apellido_profesionista' ||
          param === 'segundo_apellido_profesionista' ||
          param === 'correo_electronico' ||
          param === 'fecha_de_expedicion' ||
          param === 'modalidad_de_titulacion' ||
          param === 'fecha_examen_profesional' ||
          param === 'fecha_exencion_examen_profesional' ||
          param === 'cumplio_servicio_social' ||
          param === 'fundamento_legal_servicio_social' ||
          param === 'entidad_federativa_expedicion' ||
          param === 'institucion_procedencia' ||
          param === 'tipo_estudio_antecedente' ||
          param === 'entidad_federativa_antecedente' ||
          param === 'fecha_inicio_antecedente' ||
          param === 'fecha_terminacion_antecedente' ||
          param === 'numero_cedula'
        ) {
          this.campo = param
        }
      }

      if(this.campo) {
        this.$router.replace('#' + this.campo)
      }

      if(!this.campo || this.campo === 'nombre_campus') {
        this.getCampuses()
      }

      if(!this.campo || this.campo === 'nombre_carrera') {
        this.getCarreras()
      }

      if(!this.campo || this.campo === 'modalidad_de_titulacion') {
        this.getCatalogoModalidadTitulacion()
      }

      if(!this.campo || this.campo === 'autorizacion_reconocimiento') {
        this.getCatalogoAutorizacionReconocimiento()
      }

      if(!this.campo || this.campo === 'fundamento_legal_servicio_social') {
        this.getCatalogoFundamentoLegalServicioSocial()
      }

      if(!this.campo || this.campo === 'entidad_federativa_expedicion') {
        this.getCatalogoEntidadFederativa()
      }

      if(!this.campo || this.campo === 'tipo_estudio_antecedente') {
        this.getCatalogoTipoEstudioAntecedente()
      }

      if(!this.campo || this.campo === 'entidad_federativa_antecedente') {
        this.getCatalogoEntidadFederativa()
      }

      this.getTitulo()
    },

    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },

      getTitulo() {
        axios
          .get(api.path('titulos.titulos.single', { id: this.$route.params.id, id2: this.$route.params.id2 } ), {
            params: {
              campo: this.campo
            }
          })
          .then(res => {
            this.form = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCampuses() {
        axios
          .get(api.path('campus'))
          .then(res => {
            this.campuses = res.data.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCarreras() {
        axios
          .get(api.path('carreras'), {
            params: {
              titulo_id: this.$route.params.id2
            }
          })
          .then(res => {
            this.carreras = res.data.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCatalogoAutorizacionReconocimiento() {
        axios
          .get(api.path('catalogos.autorizacion_reconocimiento'))
          .then(res => {
            this.autorizacionesReconocimientos = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCatalogoModalidadTitulacion() {
        axios
          .get(api.path('catalogos.modalidad_titulacion'))
          .then(res => {
            this.modalidadesTitulacion = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCatalogoFundamentoLegalServicioSocial() {
        axios
          .get(api.path('catalogos.fundamento_legal_servicio_social'))
          .then(res => {
            this.fundamentoLegalServicioSocial = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCatalogoEntidadFederativa() {
        axios
          .get(api.path('catalogos.entidad_federativa'))
          .then(res => {
            this.entidadesFederativas = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCatalogoTipoEstudioAntecedente() {
        axios
          .get(api.path('catalogos.tipo_estudio_antecedente'))
          .then(res => {
            this.tipoEstudioAntecedente = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      submit() {
        if (this.$refs.form.validate()) {
          this.loading = true

          axios
            .put(api.path('titulos.titulos.single', { id: this.$route.params.id, id2: this.$route.params.id2 }), this.form)
            .then(res => {
              this.$toast.success('Título actualizado correctamente.')
              this.$emit('success', res.data)
            })
            .catch(err => {
              this.handleErrors(err.response.data.errors)
            })
            .then(() => {
              this.loading = false
            })
        }
      }
    }
  }
</script>
